import axios from 'axios'
import security from '@/services/security.js'

export default {
  get (scouterKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/' + scouterKey, config)
      .then(response => {
        return response.data
      })
  },
  list (courseKey, roleName) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/' + roleName + '/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  getStaffLookups (courseKey, listSpecialScouters) {
    const config = { headers: security.getAuthHeader() }
    if (listSpecialScouters === null || listSpecialScouters === undefined) {
      listSpecialScouters = true
    }
    return axios.get('/scouter/staff/lookup/' + courseKey + '/' + listSpecialScouters, config)
      .then(response => {
        return response.data
      })
  },
  getParticipantLookups (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/participant/lookup/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  getProgramPositions () {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/program/positions', config)
      .then(response => {
        return response.data
      })
  },
  getStaffCourseScouterLookups (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/lookup/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  getStaffBios (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/staff/bios/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  getParticipantBios (courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/participant/bios/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  getParticipantAdvisors (courseKey, scouterKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/participant/' + scouterKey + '/advisors/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  removeMemberFromStaff (courseKey, courseScouterId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/scouter/staff/' + courseKey + '/' + courseScouterId, config)
      .then(response => {
        return response.data
      })
  },
  removeParticipant (courseKey, courseScouterId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/scouter/participant/' + courseKey + '/' + courseScouterId, config)
      .then(response => {
        return response.data
      })
  },
  addCourseScouter (courseKey, scouterFullName, courseScouterType) {
    const config = { headers: security.getAuthHeader() }
    const msg = { CourseKey: courseKey, ScouterName: scouterFullName, CourseScouterType: courseScouterType }
    return axios.post('/scouter/coursescouter/new', msg, config)
      .then(response => {
        return response.data
      })
  },
  updateScouterFromCore (courseKey, scouterCore, courseScouterTypeName) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/scouter/' + courseKey + '/core/' + courseScouterTypeName, scouterCore, config)
      .then(response => {
        return response.data
      })
  },
  update (scouter) {
    const config = { headers: security.getAuthHeader() }
    return axios.put('/scouter', scouter, config)
      .then(response => {
        return response.data
      })
  },
  updateScouterField (scouterKey, fieldName, fieldValue) {
    const config = { headers: security.getAuthHeader() }
    const msg = { FieldName: fieldName, FieldValue: fieldValue }
    return axios.put('/scouter/' + scouterKey + '/field', msg, config)
      .then(response => {
        return response.data
      })
  },
  getCourseScouterOverview (scouterKey, courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/' + scouterKey + '/overview/' + courseKey, config)
      .then(response => {
        return response.data
      })
  },
  getCourseStaffInfo (scouterKey, courseKey) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/scouter/staff/' + courseKey + '/info/' + scouterKey, config)
      .then(response => {
        return response.data
      })
  }
}
